import React, { useEffect, useState } from 'react';
import PeriodsComponent from './PeriodsComponent';
import PropTypes from 'prop-types';
import { INSURED_PERIODS_QUERY } from '../queries';
import { useQueryWithSimpleErrorHandling } from 'hooks';
import { FakeText } from '@totalsoft/rocket-ui';

const PeriodsContainer = ({ resetPeriodsLens, periodsLens, validationPeriods, selectedPeriods, insuranceTypeCode, readOnly }) => {
  const [periodRange, setPeriodRange] = useState({});
  const [periods, setPeriods] = useState([]);

  const { loading: periodsLoading } = useQueryWithSimpleErrorHandling(INSURED_PERIODS_QUERY, {
    variables: { insuranceTypeCode: insuranceTypeCode },
    skip: !insuranceTypeCode,
    onCompleted: data => {
      setPeriodRange({
        min: data?.periodRange.min,
        max: data?.periodRange.max
      });
    }
  });

  useEffect(() => {
    let list = [];
    for (var i = periodRange.min; i <= periodRange.max; i++) list.push({ id: i });
    setPeriods(list);
  }, [periodRange]);

  useEffect(() => {
    if (selectedPeriods === undefined) return;

    let list = [];

    periods.forEach(period => {
      const isSelected = selectedPeriods.find(x => x === period.id);
      list.push({ id: period.id, selected: isSelected });
    });

    selectedPeriods.forEach(period => {
      if (!list.find(x => x.id === period)) list.push({ id: period, selected: true });
    });

    resetPeriodsLens(list);
  }, [selectedPeriods, periods, resetPeriodsLens]);

  return periodsLoading ? (
    <FakeText lines={3} />
  ) : (
    <PeriodsComponent periodsLens={periodsLens} validationPeriods={validationPeriods} readOnly={readOnly} />
  );
};

PeriodsContainer.propTypes = {
  resetPeriodsLens: PropTypes.func.isRequired,
  periodsLens: PropTypes.object.isRequired,
  validationPeriods: PropTypes.object,
  selectedPeriods: PropTypes.array,
  insuranceTypeCode: PropTypes.string,
  readOnly: PropTypes.bool.isRequired
};

export default PeriodsContainer;
